import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
let inject = ['$scope', '$timeout', '$rootScope', '$uibModalInstance', 'modalOptions', 'LoginService', 'SessionService', '$state','$uibModal','SharedService','CartService'];

class ModalSelectBranchController {
    constructor($scope, $timeout, $rootScope,$uibModalInstance, modalOptions, LoginService, SessionService, $state,$uibModal,SharedService,CartService) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.LoginService = LoginService;
        this.$state = $state;
        this.SessionService = SessionService;
        this.$uibModalInstance = $uibModalInstance;
        this.$uibModal = $uibModal;
        this.SharedService = SharedService;
        this.CartService = CartService;
        this.modalOptions = Object.assign({}, modalOptions);
        this.state = {};
        this.branchUserB2B={};

        this.activate();
        this.minCaracterSearch = 3;
        console.log(this.modalOptions.branches.length )
        if(this.modalOptions.branches.length <= 24){
            this.flagSelectBranch = true;
        }else{
            this.flagSelectBranch = false;
        }
    }

    activate() {
        if(this.flagSelectBranch) {
            if (this.modalOptions.currentBranch) {
                this.branchUserB2B.id = this.modalOptions.currentBranch.id;
                this.branchUserB2B.text = this.modalOptions.currentBranch.code + " - " + this.modalOptions.currentBranch.name + " - " + this.modalOptions.currentBranch.location.fullname;
                this.branchUserB2B.select = true;
            }
        }else{
            this.branchUserB2B=null;
        }
    }

    getBranchsByFastSearch(searchBranchText) {

        this.branchUserB2B.select = false;
        this.branchUserB2B.fastSearch = [];
        this.branchUserB2B.loadingByFastSearh = false;
        this.branchUserB2B.loadedByFastSearch = false;
        this.branchUserB2B.errorLoadingByFastSearch = false;


        if (searchBranchText.length >= this.minCaracterSearch) {
            let userId = '';
            try {
                userId = this.modalOptions.userData.currentUser.userId;
            } catch (e) {
            }

            this.branchUserB2B.loadingByFastSearh = true;
            this.LoginService.branchBySearchText({
                'text': searchBranchText,
                'user': userId

            }).then(response => {
                this.branchUserB2B.loadingByFastSearh = false;
                this.branchUserB2B.loadedByFastSearch = true;
                //console.log(response);
                this.branchUserB2B.fastSearch = response.operatingCenters;
            }).catch(reason => {
                this.branchUserB2B.loadingByFastSearh = false;
                this.branchUserB2B.loadedByFastSearch = true;
                this.branchUserB2B.errorLoadingByFastSearch = true;
            });
        }

    }
    setBranch(BranchByFastSearch) {
        this.branchUserB2B.id  = BranchByFastSearch.id;
        this.branchUserB2B.select = true;
        this.branchUserB2B.text = BranchByFastSearch.code + " - "+ BranchByFastSearch.name + " - " + BranchByFastSearch.location.fullname;

    }

    getTextOptionBranch(branchByFastSearch, flag='select'){
        let textOption = branchByFastSearch.code + ' - ' + branchByFastSearch.name + ' - ' + branchByFastSearch.address + ' - ' + branchByFastSearch.location.fullname ;
        let maxLength = textOption.length;

        if(flag=='select') {
            maxLength = 100;
        }else if(flag=='autocomplete'){
            maxLength = 80;
        }

        if (textOption.length > maxLength) {
            textOption = textOption.substring(0, maxLength) + "...";
        }
        return textOption;
    }


    setOperatingCenter(branchId) {

        this.state.saving = true;

        let userId = '';
        let mesaggeChange = '';
        try {
            userId = this.modalOptions.userData.currentUser.userId;
            mesaggeChange = this.modalOptions.cmsMessage.MENSAJE_CAMBIO_SUCURSAL;
        } catch (e) {
        }

        this.LoginService.setOperatingCenter(branchId, userId).then(response => {
            this.state.saving = false;
            this.state.saved = true;
            if (!response.error) {
                // Set the current client
                try {
                    let newCurrentClient = JSON.parse(global.localStorage.currentClient);
                    newCurrentClient.operatingCenter = response.branch;
                    newCurrentClient.seller = response.seller;
                    this.SessionService.put('currentClient', newCurrentClient);
                    this.SessionService.put('cartId', response.cartID);

                    if (response.validaVolumenCompra) {
                        this.SharedService.verifyVolumePurchaseBasket({ 'cartId': response.cartID }).then(volumenResponse => {
                            if (!volumenResponse.error) {
                                if (!volumenResponse.pesoValidoBodega) {
                                    this.ok();
                                    let idCiudad = response.branch.ciudad_id;
                                    let idUsuario = this.modalOptions.userData.currentUser.userId;
                                    this.cambiarSucursalVolumenItems(response.cartID, idCiudad, idUsuario);
                                } else {
                                    // Mejorar esto Jean
                                    this.$state.go('home.salesHome');
                                    this.$timeout(() => {
                                        this.$state.reload();
                                    }, 500);
                                    this.ok();
                                    if (mesaggeChange !== '') {
                                        mesaggeChange = mesaggeChange;
                                        let optionsMessage = {
                                            title: 'Notificación',
                                            isHtml: true,
                                            content: mesaggeChange,
                                            size: '',
                                            showBottonCancel: false,
                                            textActionCancel: '',
                                            textAction: 'Aceptar'
                                        };
                                        return this.messageResponse(optionsMessage);
                                    }
                                }
                            }
                        });
                    } else {
                        // Mejorar esto Jean
                        this.$state.go('home.salesHome');
                        this.$timeout(() => {
                            this.$state.reload();
                        }, 500);
                        this.ok();
                        if (mesaggeChange !== '') {
                            mesaggeChange = mesaggeChange;
                            let optionsMessage = {
                                title: 'Notificación',
                                isHtml: true,
                                content: mesaggeChange,
                                size: '',
                                showBottonCancel: false,
                                textActionCancel: '',
                                textAction: 'Aceptar'
                            };
                            return this.messageResponse(optionsMessage);
                        }
                    }
                } catch (e) {
                    // console.log(e);
                    this.state.saving = false;
                    this.state.error = true;
                }

            } else {
                this.state.error = true;
            }
        }).catch(reason => {
            this.state.saving = false;
            this.state.error = true;
        });
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }

    ok() {
        this.$uibModalInstance.close(this.modalOptions.userData);
    }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }

    cambiarSucursalVolumenItems(cartId, idCiudad, idUsuario) {
        this.CartService.getShippingMode(cartId).then(response => {
            if (response.modalidad) {
                this.setSucursalesPorModalidad(response, cartId, idCiudad, idUsuario);
            } else {
                this.obtenerSucursalSecundaria(cartId, idCiudad, idUsuario);
            }
        });
    }

    setSucursalesPorModalidad(response, cartId, idCiudad, idUsuario) {
        let data = {
            'userId': idUsuario,
            'ciudadId': idCiudad
        };
        let tipoModalidad = response.modalidad.tipo_modalidad;
        // Si la modalidad es recoge
        if (tipoModalidad == 0) {
            this.CartService.getSecondaryBranch(data).then(response => {
                let idSucursalSecundaria = response.listaSucursales[0].id;
                if (idSucursalSecundaria != null) {
                    if (this.branchUserB2B != idSucursalSecundaria) {
                        this.setSucursalSecundariaRecogeEntrega(idSucursalSecundaria, idUsuario, cartId);
                    } else {
                        this.$state.go('home.salesHome');
                        this.$timeout(() => {
                            this.$state.reload();
                        }, 500);
                        this.ok();
                        let mesaggeChange = this.modalOptions.cmsMessage.MENSAJE_CAMBIO_SUCURSAL;
                        if (mesaggeChange !== '') {
                            mesaggeChange = mesaggeChange;
                            let optionsMessage = {
                                title: 'Notificación',
                                isHtml: true,
                                content: mesaggeChange,
                                size: '',
                                showBottonCancel: false,
                                textActionCancel: '',
                                textAction: 'Aceptar'
                            };
                            return this.messageResponse(optionsMessage);
                        }
                    }
                }
            });
            this.CartService.updateDateCart(cartId).then(response => {
                return response;
            });
            // Si es a domicilio
        } else {
            this.CartService.getSecondaryBranch(data).then(response => {
                let idSucursalSecundaria = response.listaSucursales[0].id;
                let idCiudad = response.listaSucursales[0].ciudad_id;

                if (idCiudad != null && idSucursalSecundaria != null && cartId != null) {
                    this.CartService.updatePromiseCart(cartId, idSucursalSecundaria, idCiudad).then(response => {
                        let aplicaServicioDescargue = response.aplicaServicioDescargue;
                        if (idSucursalSecundaria != null) {
                            if(this.branchUserB2B != idSucursalSecundaria){
                                this.setSucursalSecundariaTipoDomicilio(idSucursalSecundaria, idUsuario, aplicaServicioDescargue, cartId);
                            } else{
                                this.$state.go('home.salesHome');
                                    this.$timeout(() => {
                                        this.$state.reload();
                                    }, 500);
                                    this.ok();
                                    let mesaggeChange = this.modalOptions.cmsMessage.MENSAJE_CAMBIO_SUCURSAL;
                                    if (mesaggeChange !== '') {
                                        mesaggeChange = mesaggeChange;
                                        let optionsMessage = {
                                            title: 'Notificación',
                                            isHtml: true,
                                            content: mesaggeChange,
                                            size: '',
                                            showBottonCancel: false,
                                            textActionCancel: '',
                                            textAction: 'Aceptar'
                                        };
                                        return this.messageResponse(optionsMessage);
                                    }
                            }
                        }
                    });
                }
            });
        }
    }

    setSucursalSecundariaRecogeEntrega(idSucursal, userId, cartId) {

        let mensajeCambioSucursal = '';
        let mensajeCambioHorarioBodega = '';
        let allMessage = [];
        try {
            mensajeCambioSucursal = this.modalOptions.cmsMessage.B2B_MENSAJE_CAMBIO_SUCURSAL;
            mensajeCambioHorarioBodega = this.modalOptions.cmsMessage.B2B_MENSAJE_CAMBIO_HORARIO_BODEGA;
            allMessage.push(mensajeCambioSucursal);
            allMessage.push(mensajeCambioHorarioBodega);

        } catch (e) {
        }
        this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
            if (!response.error) {
                // Set the current client
                try {
                    let newCurrentClient = JSON.parse(global.localStorage.currentClient);
                    newCurrentClient.operatingCenter = response.branch;
                    newCurrentClient.seller = response.seller;
                    this.SessionService.put('currentClient', newCurrentClient);
                    this.SessionService.put('cartId', response.cartID);
                    this.$rootScope.$broadcast('actualizarHeader', response.branch);

                    this.SharedService.assignWarehouseBasketCode({ 'cartId': cartId }).then(response => {
                        if (!response.error) {
                            if (allMessage !== null) {
                                this.$state.go('home.salesHome');
                                this.$timeout(() => {
                                    this.$state.reload();
                                }, 500);
                                this.showModalAllMessage(allMessage);
                            }
                        }
                    });
                } catch (e) {
                }

            } else {
                console.log('Ocurrio un erro al cambiar la sucursal')
            }
        }).catch(reason => {
            this.state.saving = false;
            this.state.error = true;
        });
    }

    setSucursalSecundariaTipoDomicilio(idSucursal, userId, aplicaServicioDescargue, cartId) {

        let mensajeCambioSucursal = '';
        let mensajeDestinoNoDisponilble = '';
        let mensajeCambioPromesa = '';
        let allMessage = [];

        try {
            mensajeCambioSucursal = this.modalOptions.cmsMessage.B2B_MENSAJE_CAMBIO_SUCURSAL;
            mensajeCambioPromesa = this.modalOptions.cmsMessage.B2B_MENSAJE_CAMBIO_PROMESA;
            allMessage.push(mensajeCambioSucursal);
            allMessage.push(mensajeCambioPromesa);

            if (!aplicaServicioDescargue) {
                this.servicioDescargue = aplicaServicioDescargue;
                mensajeDestinoNoDisponilble = this.modalOptions.cmsMessage.B2B_MENSAJE_INFORMATITVO_DESTINOS_NO_DISPONIBLES;
                allMessage.push(mensajeDestinoNoDisponilble);
            }

        } catch (e) {
        }
        this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
            if (!response.error) {
                // Set the current client
                try {
                    let newCurrentClient = JSON.parse(global.localStorage.currentClient);
                    newCurrentClient.operatingCenter = response.branch;
                    newCurrentClient.seller = response.seller;
                    this.SessionService.put('currentClient', newCurrentClient);
                    this.SessionService.put('cartId', response.cartID);
                    this.$rootScope.$broadcast('actualizarHeader', response.branch);

                    this.SharedService.assignWarehouseBasketCode({ 'cartId': cartId }).then(response => {
                        if (!response.error) {

                            if (allMessage !== null) {
                                this.$state.go('home.salesHome');
                                this.$timeout(() => {
                                    this.$state.reload();
                                }, 500);
                                this.showModalAllMessage(allMessage);
                            }
                        }
                    });
                } catch (e) {
                }

            } else {
                console.log('ocurrio un error al cambiar de sucursal')
            }
        }).catch(reason => {
            this.state.saving = false;
            this.state.error = true;
        });
    }

    showModalAllMessage(allMesagge) {
        let contentDynamic = 'Se realizaron las siguientes modificaciones: </br>';

        for (let i = 0; i < allMesagge.length; i++) {
            contentDynamic += `
                                <ul><li>` + allMesagge[i] + `</li></ul>`;
        }

        if (contentDynamic != '') {
            let optionsMessage = {
                title: 'Actualización de precios',
                isHtml: true,
                content: contentDynamic,
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar',
                backdrop: 'static'
            };

            let modalInstance = this.$uibModal.open({
                animation: true,
                template: modalConfirmation,
                controller: 'ModalResponseController',
                controllerAs: 'mdCtrl',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    modalOptions: () => optionsMessage
                }
            });
            modalInstance.result.then(() => {
            }).catch(() => {

            });
        }
    }

    obtenerSucursalSecundaria(cartId, idCiudad, idUsuario) {
        let data = {
            'userId': idUsuario,
            'ciudadId': idCiudad
        };
        // Si la modalidad es recoge
        if (data != null) {
            this.CartService.getSecondaryBranch(data).then(response => {
                let idSucursalSecundaria = response.listaSucursales[0].id;
                if (idSucursalSecundaria != null) {
                    if (this.branchUserB2B != idSucursalSecundaria) {
                        this.setSucursalSecundariaSinModalidad(idSucursalSecundaria, idUsuario, cartId);
                    } else {
                        this.$state.go('home.salesHome');
                        this.$timeout(() => {
                            this.$state.reload();
                        }, 500);
                        this.ok();
                        let mesaggeChange = this.modalOptions.cmsMessage.MENSAJE_CAMBIO_SUCURSAL;
                        if (mesaggeChange !== '') {
                            mesaggeChange = mesaggeChange;
                            let optionsMessage = {
                                title: 'Notificación',
                                isHtml: true,
                                content: mesaggeChange,
                                size: '',
                                showBottonCancel: false,
                                textActionCancel: '',
                                textAction: 'Aceptar'
                            };
                            return this.messageResponse(optionsMessage);
                        }
                    }
                }
            });
            this.CartService.updateDateCart(cartId).then(response => {
                return response;
            });
        }
    }

    setSucursalSecundariaSinModalidad(idSucursal, userId, cartId) {

        let mensajeCambioSucursal = '';
        let allMessage = [];
        try {
            mensajeCambioSucursal = this.modalOptions.cmsMessage.B2B_MENSAJE_CAMBIO_SUCURSAL;
            allMessage.push(mensajeCambioSucursal);
        } catch (e) {
        }
        this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
            if (!response.error) {
                // Set the current client
                try {
                    let newCurrentClient = JSON.parse(global.localStorage.currentClient);
                    newCurrentClient.operatingCenter = response.branch;
                    newCurrentClient.seller = response.seller;
                    this.SessionService.put('currentClient', newCurrentClient);
                    this.SessionService.put('cartId', response.cartID);

                    this.$rootScope.$broadcast('actualizarHeader', response.branch);
                    this.SharedService.assignWarehouseBasketCode({ 'cartId': cartId }).then(response => {
                        if (!response.error) {
                            if (allMessage !== null) {
                                this.$state.go('home.salesHome');
                                this.$timeout(() => {
                                    this.$state.reload();
                                }, 500);
                                this.showModalAllMessage(allMessage);
                            }
                        }
                    });
                } catch (e) {
                }

            } else {
                console.log('Ocurrio un erro al cambiar la sucursal')
            }
        }).catch(reason => {
            this.state.saving = false;
            this.state.error = true;
        });
    }
}

ModalSelectBranchController.$inject = inject;

export default ModalSelectBranchController;



/** WEBPACK FOOTER **
 ** ./www/components/login/modal-select-branch-b2b-user/modal-select-branch-b2b-user.controller.js
 **/